module.exports = __webpack_public_path__ + "img/svg/background-navbar-header.747937d24c1114f0bbcb6ac6b01a4202.svg";